import { Button, Flex, Typography } from "antd"

export const BankDetailsStepUi = () => {
  return (
    <Typography.Text>
      To withdraw fiat currency from your balance, you must first add your
      corporate bank details in this section.
      <br />
      If you encounter any issues, please contact your Key Account Manager or
      reach out to us via the chat icon in the bottom right corner.
    </Typography.Text>
  )
}
